import { CountUp } from 'countup.js'
import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export class NumbersBlockProgress {
  constructor() {
    this.wrapper = document.querySelector('.js-numbers_block_progress')

    if(!this.wrapper) { return false }

    this.init()
  }

  init = () => {
    this.setDefaults()
    this.createScrollTrigger()
    this.scrollToEvent()
  }

  scrollToEvent = () => {
    this.button = this.wrapper.querySelector('.js-button')

    if (!this.button) return false

    this.map = document.querySelector('.js-interactive-map-wrapper')

    this.button.addEventListener('click', (e) => {
      e.preventDefault()

      window.scrollTo({
        top: this.map.getBoundingClientRect().top + window.scrollY + 50,
        left: 0,
        behavior: 'smooth'
      })

      return false;
    })
  }

  setDefaults = () => {
    this.items = [...document.querySelectorAll('.js-numbers_block_progress-item')]
    this.entered = false
  }

  createScrollTrigger = () => {
    this.scrolltrigger = ScrollTrigger.create({
      trigger: this.wrapper,
      start: `top center`,
      makers: true,
      onEnter: () => {
        if (!this.entered) {
          this.items.forEach(item => {
            new Number(item)
          })

          this.entered = true
        }
      }
    })
  }
}

class Number {
  constructor(item) {
    this.item = item

    this.setDefaults()
    this.count()
    this.progressBar()
  }

  setDefaults = () => {
    this.number = this.item.querySelector('.js-number')
    this.countToNumber = this.number.dataset.counttonumber

    this.bar = this.item.querySelector('.js-numbers_block_progress-progressbar')
    this.width = this.bar.dataset.width

    this.decimal = 0

    if (this.countToNumber.includes(".")) {
      this.parts = this.countToNumber.split(".")
      this.decimal = this.parts[1].length
    }

    this.options = {
      useEasing: true,
      useGrouping: true,
      separator: ',',
      decimalPlaces: this.decimal,
    }
  }

  progressBar = () => {
    gsap.to(this.bar, {
      width: `${this.width}%`,
      duration: 2
    })
  }

  count = () => {
    this.numAnim = new CountUp(this.number, this.countToNumber, this.options)
    this.numAnim.start()
  }
}
